<template>
  <div class="section">
    <div class="content">
      <h1>Account</h1>

      <p>You are on the free plan. You can monitor up to 3 topics.</p>

      <p>
        <a href="/upgrade/" class="button is-info">Upgrade now</a>
      </p>
    </div>
  </div>
</template>

<script>

export default {
  components: {},

  data() {
    return {}
  }
}


</script>
